export const SET_BANNERS = 'SET_BANNERS' as const;
export const SET_IS_FIRST_BANNER_LOADED = 'SET_IS_FIRST_BANNER_LOADED' as const;
export const RESET_BANNERS = 'RESET_BANNERS' as const;